import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Seo from "../../components/Seo/Seo";
import site from "../../data/site";
import { servicesItemList } from "../../seo/schema";
import classes from "./Services.module.css";

export default function ServicesIndex() {
  return (
    <main className="page">
      <Seo
        title={site.servicesIndex.title}
        description={site.servicesIndex.description}
        path="/services"
        jsonLd={servicesItemList()}
      />
      <div className={classes.page}>
        <Container>
          <div className="sectionEyebrow">What we do</div>
          <h1 className="sectionTitle">Services built to win you customers</h1>
          <p className={`sectionLead ${classes.lead}`}>{site.servicesIndex.lead}</p>
          <div className={classes.indexList}>
            {site.services.map((service) => (
              <article key={service.slug} className={classes.indexItem}>
                <img
                  src={service.image}
                  alt={service.imageAlt}
                  width={service.width}
                  height={service.height}
                  loading="lazy"
                  decoding="async"
                />
                <div>
                  <h2>{service.title}</h2>
                  <p>{service.hook}</p>
                  <Link className={classes.more} to={`/services/${service.slug}`}>
                    Learn more about {service.title}
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </Container>
      </div>
      <Footer />
    </main>
  );
}
